export enum DataTableImportMode {
    Append = 'Append',
    Replace = 'Replace',
    Update = 'Update',
}

export interface DataTableImportModeOption {
    id: DataTableImportMode;
    name: string;
    description: string;
}

export const DataTableImportModeOptions: DataTableImportModeOption[] = [
    {
        id: DataTableImportMode.Append,
        name: 'Append',
        description: 'Add the file rows after the existing rows.',
    },
    {
        id: DataTableImportMode.Replace,
        name: 'Replace',
        description: 'Replace all existing rows with the file rows.',
    },
    {
        id: DataTableImportMode.Update,
        name: 'Update',
        description: 'Update existing rows that match the file rows by an identifier column.',
    },
];
